export const RANK_MEDALS = ['🥇', '🥈', '🥉'] as const;

export const TREND_ICONS = { up: '↑', down: '↓', same: '—' } as const;

export const MEDAL_COLORS = {
  gold: '#F6C646',
  silver: '#C0C0C0',
  bronze: '#CD7F32',
} as const;

/** Copy for the always-visible "your standing" bar (squad + global leaderboards). */
export const SELF_BAR_COPY = {
  YOU: 'YOU',
  POINTS_LABEL: 'pts',
  RANK_PREFIX: '#',
} as const;

/** Gap (px) left above the jumped-to row so it sits comfortably below the top edge. */
export const SELF_BAR_JUMP_TOP_OFFSET = 24;

/** accessibilityLabel for the "your standing" bar — keeps a11y copy out of JSX. */
export const buildSelfBarA11yLabel = (rank: number, points: number): string =>
  `Your standing: rank ${rank}, ${points} points. Tap to jump to your row.`;

/** Stable testID for the "your standing" bar pressable. */
export const SELF_BAR_TEST_ID = 'leaderboard-self-bar';
